export default [
  {
    title: '配置ID',
    key: 'id',
    width: 38
  },
  {
    title: '账号',
    key: 'adAccountName',
    overflow: true
  },
  {
    title: '游戏',
    key: 'gameName',
    width: 180,
    overflow: true
  },
  {
    title: '落地页地址',
    key: 'logidUrl',
    width: 220,
    overflow: true
  },

  {
    title: '数据上报token',
    key: 'token',
    width: 140,
    overflow: true
  },
  {
    title: '创建人',
    key: 'opName'
  },
  {
    title: '更新人',
    key: 'upOpName'
  },
  {
    title: '创建时间',
    key: 'addTime'
  },
  {
    title: '更新时间',
    key: 'updateTime'
  },
  {
    title: '操作',
    key: 'control'
  }
]
